import styled, { css } from 'styled-components';
import {
  colorBlack900,
  mediaQueryMobileLargeMin,
  mediaQueryMobileMin,
} from 'styles';
import { Paragraph } from 'components/Typography';

export const Title = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 24px 0;

  & > ul {
    display: flex;
    width: 100%;
  }

  & > ul button svg {
    margin-top: 1px;
  }

  @media ${mediaQueryMobileMin} {
    flex-direction: row;

    & > ul {
      width: unset;
    }
  }
`;

export const Text = styled(Paragraph)`
  color: ${colorBlack900};
  margin-bottom: 16px;
  align-self: flex-start;

  @media ${mediaQueryMobileLargeMin} {
    margin-bottom: 0;
    align-self: unset;
  }
`;

export const DateButtons = styled.div`
  position: relative;
  margin-top: 8px;
  width: 100%;
  overflow: hidden;

  & > div {
    overflow: scroll;
  }

  @media ${mediaQueryMobileLargeMin} {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  ${({ $fitRow }) =>
    $fitRow &&
    css`
      @media ${mediaQueryMobileLargeMin} {
        flex-wrap: wrap;
        column-gap: 12px;

        & > div:first-child {
          flex: 0 0 auto;
          max-width: 100%;
          overflow: visible;
        }

        & > div:last-child {
          overflow: visible;
        }
      }
    `}
`;

export const InputsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 9px;

  @media ${mediaQueryMobileLargeMin} {
    margin-top: 0;
  }

  ${({ $compact }) =>
    $compact &&
    css`
      @media ${mediaQueryMobileLargeMin} {
        flex: 1 1 240px;
        min-width: 240px;
        justify-content: flex-end;

        button {
          min-width: 0;
          width: auto;
          flex: 1 1 0;
          padding-right: 8px;
          padding-left: 8px;
        }

        & > div {
          flex-shrink: 0;
        }
      }
    `}
`;

export const Dash = styled.div`
  margin: 0 4px;
  background: ${colorBlack900};
  height: 1px;
  width: 8px;
  margin-top: 8px;

  @media ${mediaQueryMobileLargeMin} {
    margin-top: 0;
  }
`;
